module.exports = __webpack_public_path__ + "img/bg-top-nav-summer.1a9bcdae.svg";